import { Communication } from "neo-games";
import { DataManager } from "../../../Managers/DataManager";
import { GameData } from "../Datas/GameData";
import { HtmlController } from "../../../HTMLComponents/HtmlController";
import { BetManager } from "../../../Managers/BetManager";
import { RouletteBetType } from "../../../CustomComponents/RouletteBetType";
import { StatisticsManager } from "../../../Managers/StatisticsManager";

export class Statistics {
    private readonly redBar: HTMLElement;
    private readonly blackBar: HTMLElement;
    private readonly redBlackZeroBar: HTMLElement;
    private readonly evenBar: HTMLElement;
    private readonly oddBar: HTMLElement;
    private readonly evenOddZeroBar: HTMLElement;
    private readonly lowBar: HTMLElement;
    private readonly highBar: HTMLElement;
    private readonly lowHighZeroBar: HTMLElement;

    private readonly redNumbers: Array<number>;

    private hotNumbers: Array<number>;
    private coldNumbers: Array<number>;

    constructor() {
        this.redBar = document.getElementById("redBarStatistic");
        this.blackBar = document.getElementById("blackBarStatistic");
        this.redBlackZeroBar = document.getElementById("redBlackZeroBarStatistic");
        this.evenBar = document.getElementById("evenBarStatistic");
        this.oddBar = document.getElementById("oddBarStatistic");
        this.evenOddZeroBar = document.getElementById("evenOddZeroBarStatistic");
        this.lowBar = document.getElementById("lowBarStatistic");
        this.highBar = document.getElementById("highBarStatistic");
        this.lowHighZeroBar = document.getElementById("lowHighZeroBarStatistic");

        this.redNumbers = BetManager.getBetNumbersByBetType(RouletteBetType.RedOrBlack, 0);

        this.hotNumbers = [-1, -1, -1, -1];
        this.coldNumbers = [-1, -1, -1, -1];

        HtmlController.toggleElementsByClass("numberFrequency", false);
    }

    update(statistics: Communication.Game.IRouletteStatistics): void {
        if (statistics != null) {
            HtmlController.toggleElementsByClass("numberFrequency", true);

            //hot numbers
            this.hotNumbers = this.getNumbersArray(this.hotNumbers, statistics.hotNumbers);
            if (this.hotNumbers != null) {
                for (let i = 0; i < this.hotNumbers.length; i++) {
                    let currentValue = parseInt(DataManager.getDataById(GameData.DataHotNumbers + i + "_NUMBER"));
                    DataManager.updateGameDataFromModule(
                        GameData.DataHotNumbers + i + "_NUMBER",
                        this.hotNumbers[i].toString(),
                    );
                    DataManager.updateDataElement(GameData.DataHotNumbers + i + "_NUMBER");
                    this.showChanges(
                        currentValue,
                        this.hotNumbers[i] != currentValue,
                        GameData.DataHotNumbers + i + "_NUMBER",
                    );
                }
            }

            //cold numbers
            this.coldNumbers = this.getNumbersArray(this.coldNumbers, statistics.coldNumbers);
            if (this.coldNumbers != null) {
                for (let i = 0; i < this.coldNumbers.length; i++) {
                    let currentValue = parseInt(DataManager.getDataById(GameData.DataColdNumbers + i + "_NUMBER"));
                    DataManager.updateGameDataFromModule(
                        GameData.DataColdNumbers + i + "_NUMBER",
                        this.coldNumbers[i].toString(),
                    );
                    DataManager.updateDataElement(GameData.DataColdNumbers + i + "_NUMBER");
                    this.showChanges(
                        currentValue,
                        this.coldNumbers[i] != currentValue,
                        GameData.DataColdNumbers + i + "_NUMBER",
                    );
                }
            }

            //red black
            if (statistics.red != null && statistics.black != null) {
                DataManager.updateGameDataFromModule(GameData.DataRedNumbers, statistics.red.toString());
                DataManager.updateGameDataFromModule(GameData.DataBlackNumbers, statistics.black.toString());

                if (this.redBar != null && this.blackBar != null && this.redBlackZeroBar) {
                    this.redBar.style.width = statistics.red + "%";
                    this.blackBar.style.width = statistics.black + "%";
                    this.redBlackZeroBar.style.width = (100 - statistics.red - statistics.black).toFixed(2) + "%";
                }
            }

            //even odd
            if (statistics.even != null && statistics.odd != null) {
                DataManager.updateGameDataFromModule(GameData.DataEvenNumbers, statistics.even.toString());
                DataManager.updateGameDataFromModule(GameData.DataOddNumbers, statistics.odd.toString());

                if (this.evenBar != null && this.oddBar != null && this.evenOddZeroBar) {
                    this.evenBar.style.width = statistics.even + "%";
                    this.oddBar.style.width = statistics.odd + "%";
                    this.evenOddZeroBar.style.width = (100 - statistics.even - statistics.odd).toFixed(2) + "%";
                }
            }

            //low high
            if (statistics.low != null && statistics.high != null) {
                DataManager.updateGameDataFromModule(GameData.DataLowNumbers, statistics.low.toString());
                DataManager.updateGameDataFromModule(GameData.DataHighNumbers, statistics.high.toString());

                if (this.lowBar != null && this.highBar != null && this.lowHighZeroBar) {
                    this.lowBar.style.width = statistics.low + "%";
                    this.highBar.style.width = statistics.high + "%";
                    this.lowHighZeroBar.style.width = (100 - statistics.low - statistics.high).toFixed(2) + "%";
                }
            }

            let numbersHistoryCount = statistics.numbersHistoryCount;
            if (numbersHistoryCount != null) {
                DataManager.updateGameDataFromModule(GameData.DataHistoryCount, numbersHistoryCount.toString());
            }
        }

        StatisticsManager.updateHitMapElements(statistics);
    }

    private showChanges(currentValue: number, animate: boolean, id: string): void {
        if (!isNaN(currentValue) && animate) {
            if (HtmlController.DataElements[id] != null) {
                for (let i = 0; i < HtmlController.DataElements[id].length; i++) {
                    const elem = HtmlController.DataElements[id][i];
                    const parent = elem.instance.parentElement;

                    if (parent != null) {
                        parent.classList.remove("flash");
                        parent.offsetWidth;
                        parent.classList.add("flash");
                    }
                }
            }
        }

        if (HtmlController.DataElements[id] != null) {
            for (let i = 0; i < HtmlController.DataElements[id].length; i++) {
                const elem = HtmlController.DataElements[id][i];
                const parent = elem.instance.parentElement;
                const value = parseInt(DataManager.getDataById(id));

                if (parent != null) {
                    if (value == -1) {
                        parent.classList.add("_invisible");
                    } else {
                        parent.classList.remove("_invisible");
                    }
                }
            }
        }
    }

    private getNumbersArray(
        currentArray: Array<number>,
        data: Array<{ number: number; count: number }>,
    ): Array<number> {
        const newArray: Array<number> = [];
        const newValueIndexes: Array<number> = [];
        const oldValueIndexes: Array<number> = [];

        if (currentArray.indexOf(-1) > -1) {
            currentArray = currentArray.map((value) => (value == -1 ? -2 : value));
        }

        for (let i = 0; i < currentArray.length; i++) {
            if (data[i] != null) {
                newArray.push(data[i].number);
            } else {
                newArray.push(-1);
            }
        }

        for (let i = 0; i < currentArray.length; i++) {
            //check for new values
            if (currentArray.indexOf(newArray[i]) == -1) {
                newValueIndexes.push(i);
            }

            //check for values to be deleted
            if (newArray.indexOf(currentArray[i]) == -1) {
                oldValueIndexes.push(i);
            }
        }

        for (let i = 0; i < oldValueIndexes.length; i++) {
            currentArray[oldValueIndexes[i]] = newArray[newValueIndexes[i]];
        }

        return currentArray;
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Channels/Common/Statistics/Statistics.ts
 **/